module.exports = __webpack_public_path__ + "img/xskj-subtitle.b84d885a.png";